import { useQuery } from "@tanstack/react-query";
import { ColumnsType } from "antd/es/table";
import { useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import { Link } from "react-router-dom";
import { getProductsAdmin } from "../../../network/admin";
import AntTable from "../../AntTable/AntTable";
type Props = {
  isFilter: any;
  selectedRowKeys: any;
  setSelectedRowKeys: any;
  searchHeader: any;
};

const TabProducts = ({
  isFilter,
  selectedRowKeys,
  setSelectedRowKeys,
  searchHeader,
}: Props) => {
  const statusColor = (status: string) => {
    switch (status) {
      case "active":
      case "Active":
        return "#479821";
      case "blocked":
      case "Blocked":
        return "#B0B0C0";
      case "pending":
      case "Pending":
        return "#CF953D";
      default:
        return "#B0B0C0"; // Default color if status doesn't match any case
    }
  };
  const [page, setPage] = useState<number>(1);
  const { data, isLoading } = useQuery(
    ["product", isFilter, searchHeader],
    () => getProductsAdmin({ page, ...isFilter, search: searchHeader })
  );

  const columns: ColumnsType<any> = [
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Product name</div>
      ),
      dataIndex: "first_name",
      render: (text: any, record) => (
        <div className="flex items-center justify-start gap-3 mr-auto">
          <img className="object-cover w-24 h-12" src={record?.media} alt="" />
          <div className="flex flex-col justify-between gap-2">
            <div className="text-sm font-medium text-color-primary">
              {record?.name}
            </div>
            <span className="flex items-center gap-1">
              <span className="text-xs text-color-primary">
                {record?.amount}
              </span>
              <span className="text-[#75757E] text-[8px]">
                {record?.measure}
              </span>
            </span>
          </div>
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">
          Associated salon
        </div>
      ),
      dataIndex: "Associated salon",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div
          className="text-[#9999A7] flex items-center justify-start text-sm font-medium"
          dir="ltr"
        >
          {record?.locations?.map((e: any) => (
            <span>{e?.name}</span>
          ))}
        </div>
      ),
    },
    {
      title: <div className="text-[#9999A7] text-sm font-normal">Brand</div>,
      dataIndex: "Brand",

      render: (text: any, record) => (
        <div className="text-[#9999A7] flex items-center justify-start text-sm font-medium">
          {record?.brand?.name}
        </div>
      ),
    },
    {
      title: <div className="text-[#9999A7] text-sm font-normal">Stock</div>,
      dataIndex: "current_stock_quantity",

      render: (text: any, record) => (
        <div className="text-[#9999A7] flex items-center justify-start">
          <span className="text-[#9999A7] text-sm font-medium">
            {record?.current_stock_quantity}
          </span>
        </div>
      ),
    },
    {
      title: <div className="text-[#9999A7] text-sm font-normal">Price</div>,
      dataIndex: "created_at",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div
          className={` text-sm font-medium flex items-center gap-1 w-full justify-between`}
        >
          <span className="font-semibold text-color-primary">
            {record?.retail_price}
          </span>
          <span className="text-[#9999A7]">SR</span>
        </div>
      ),
    },
    {
      title: <div></div>,
      dataIndex: "edit",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <Link
          className="w-fit hover:bg-[#EEF0FF] p-2 rounded-full cursor-pointer"
          to={`${record?.name}`}
        >
          <AiOutlineEdit />
        </Link>
      ),
    },
  ];

  return (
    <div>
      <AntTable
        tableColumns={columns}
        tableData={data?.data}
        isLoading={isLoading}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        expandRowByClick={false}
        // hideArrowExpand
        selectionType={selectedRowKeys}
        setPage={setPage}
        page={page}
        total={data?.meta?.total}
      />
    </div>
  );
};

export default TabProducts;
